<template>
  <div class="row" style="height:100vh;overflow-y:auto;background-color: #e6efee !important;">
        <div class="col-md-12">
	        <div class="row">
	        	<md-toolbar class="search_toolbar" style="padding-top:2vh;box-shadow: 0 2px 4px -19px rgba(0,0,0,.2), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);">
	        		<div class="col-md-11">
		        		<p class="search_title">Search</p>
		        	</div>
	        		<div class="col-md-1">
		        		<a @click="BacktoHome()"><p class="close-word">Close&nbsp;&nbsp;<md-icon class="close-btn">close</md-icon></p></a>
		        	</div>
	        	</md-toolbar>
	        	<div class="row">
	        		<div class="col-md-1"></div>
	        		<div class="col-md-11">
			        	<md-autocomplete
				          class="search_content"
				          v-model="selectedEmployee"
				          :md-options="employees"
				          md-layout="box">
				          <label><md-icon style="color:#346168">search</md-icon>&nbsp;<span>Search...</span></label>
				        </md-autocomplete>
					</div>
				</div>
	        </div>
	        <div class="row">
				<div class="col-md-12">
					<p class="recently_search">RECENTLY SEARCHED</p>
				</div>
			</div>
			<div class="row">
                <div class="col-md-3">
                    <p class="recent_projetcs">PROJECTS</p>
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                </div>
                <div class="col-md-3">
                    <p class="recent_projetcs">Terms</p>
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                </div>
                <div class="col-md-3">
                    <p class="recent_projetcs">Forms</p>
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                </div>
                <div class="col-md-3">
                    <p class="recent_projetcs">Users</p>
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                    <hr class="search_hr">
                    <p class="recent_project_content">Lorem Ipsum</p>
                </div>
            </div>
	    </div>
	</div>
</template>

<script>
    import Vue from 'vue'
    import { EventBus } from '../event-bus.js'
  
	export default {
        name: 'Search',
	    data () {
	      return {
	        selectedEmployee: '',
	        employees: []
	      }
        },
        methods: {
            BacktoHome () {
                EventBus.$emit('closeSearch', "pp")
            }
        }
    }
</script>

<style scoped>
.search_hr {
  margin-left:10vh;
  margin-right:7vh
}
.close-word{
    font-family: Lato;
    font-size: 1.6vh;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #006871;
    text-transform: uppercase;
}
.close-btn {
  color: #073c49 !important;
}
.search_toolbar {
  background-color: #e6efee !important;
}
.search_title {
    text-transform: uppercase;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #333333;
    margin-left: 8vh
}
.search_content {
 margin-top: 5vh !important;
 width: 150vh !important;
 margin-bottom: 2vh !important;
 border: solid 1px #cccccc;
 background-color: #ffffff;
 box-shadow: none !important;
 border-radius:5.5px !important;
}
.recently_search {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #474747;
  margin-left: 10vh;
  margin-top: 5vh
}
.recent_projetcs {
  font-family: Lato;
  font-size: 14px;
  text-align: left;
  color: #346168;
  margin-left: 10vh;
  margin-top: 5vh
}
.recent_project_content {
  font-family: Lato;
  font-size: 12px;
  text-align: left;
  margin-left: 10vh;
  margin-top: 2vh;
  color: #666666;
}
.Emulsion-Testing-Variability {
  font-family: Lato;
  font-size: 14px;
  text-align: left;
  margin-left: 5vh;
  color: #346169;
}
.Emulsion-Testing-Variability-Components {
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #346169 !important;
}
.components_submission_title {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-left: 2vh;
  color: #346169 !important;
}
.components_submission_content {
  font-family: Lato;
  text-align: left;
  margin-left: 2vh;
  color: #346169 !important;
}

.save_as_draft_btn {
  width: 125.2px;
  height: 30.4px;
  border-radius: 4px;
  border: solid 1px #529da3 !important;
  color: #529da3 !important;
}
.bulk_upload_btn {
  width: 125.2px;
  height: 30.4px;
  border-radius: 4px;
  background-color: #529da3 !important;
  color: #ffffff !important;
}
.submit_form_btn {
  width: 125.2px;
  height: 30.4px;
  border-radius: 4px;
  background-color: #f16722 !important;
  color: #ffffff !important;
}
.compoent_form_card {
  background-color: #e6efee !important;
  margin-bottom: 5vh
}
.butns_card {
  background-color: #e6efee
}
.myradiobtn {
  padding-top: 5vh !important;
}
.myinputlabel {
  color: #767676;
  font-size: 16px;
}
.normal_from_Rectangle-480 {
  height: 56px !important;
  border-radius: 5px;
  border: solid 0.5px #81a1a6 !important;
  background-color: #ffffff !important;
  margin-bottom: 4vh
}
.normal_from_Rectangle-481 {
  height: 120px !important;
  border-radius: 5px;
  border: solid 0.5px #81a1a6 !important;
  background-color: #ffffff !important;
  margin-bottom: 2vh;
  text-align: left;
}
.normal_from_radio {
  margin-left: 2vh;
  margin-top: 2vh
}
.empty_state_day {
  color: #073c49;
  text-align: left;
  font-size:14px;
  font-weight: bold;
}
.empty_state_today {
  margin-left: 1vh
}
.empty_state_dots {
  color: #073c49 !important;
  margin-left: -7vh !important
}
.empty_state_content {
  font-family: Lato;
  font-size: 18px;
  text-align: left;
  color: #073c49;
}
.empty_set_project1 {
  border-radius: 5.5px;
  border: solid 1px #81a1a6;
  object-fit: contain;
  opacity: 0.3;
  background-color: #e6efee !important;
  text-align: left;
  margin-bottom: 5vh;
  height: 35vh;
}
.empty_set-card {
  margin-top: 2vh
}
.Rectangle-534 {
  width: 127px;
  height: 16px;
  background-color: #e6efee;
  margin-top:2vh;
  margin-left: 3vh;
  margin-bottom: 3vh;
}
.Rectangle-532 {
  width: 127px;
  height: 10px;
  background-color: #81a1a6;
  margin-bottom: 2vh;
}
.Rectangle-443 {
  width: 7px;
  height: 10px;
  background-color: #81a1a6;
  margin-left: 2vh;
  margin-bottom: 2vh;
}
.Rectangle-531 {
  width: 270px;
  height: 18px;
  background-color: #81a1a6;
  margin-bottom: 2vh
}
.Rectangle-533 {
  width: 270px;
  height: 12px;
  background-color: #81a1a6;
  margin-bottom: 10vh
}
.Rectangle-598 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6;
}
.Rectangle-601 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6;
  margin-left: 2vh
}
.empty_set_dashboard {
  margin-top:5vh;
}
.empty_set_dev_content {
  text-align: left;
  font-family: Lato;
}
.empty_set_deviation {
  margin-left: 1vh;
  color:#f16722
}
.empty_set_dist {
  margin-left:4vh;
  margin-right:4vh;
}
.empty_set_img {
  margin-right: 1vh
}
.empty_set_dashboard_card 
{
  border: solid 1px #81a1a6;
  background-color: #e6efee !important;
  margin-bottom: 5vh
}
.Group-503 {
  object-fit: contain;
}
.empty_set_dashboard_no {
  width: 35px;
  height: 72px;
  font-family: Lato;
  font-size: 59.7px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #e6efee !important;
}
.Rectangle-547 {
  width: 161px;
  height: 12px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Rectangle-549 {
  width: 96px;
  height: 12px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Path-417 {
  margin-left: 2vh
}
.Group-525 {
  height:45vh;
  object-fit: contain;
}
.Rectangle-536 {
  width: 127px;
  height: 16px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Rectangle-535 {
  width: 188px;
  height: 12px;
  background-color: #e6efee;
  margin-left: 2vh;
  margin-bottom: 2vh
}
.Rectangle-537 {
  width: 12px;
  height: 12px;
  background-color: #e6efee;
  margin-left: 2vh;
  margin-bottom: 2vh
}
.Rectangle-5311 {
  width: 270px;
  height: 18px;
  background-color: #e6efee;
  margin-top: 2vh
}
.Path-731 {
  width: 160px;
  height: 12px;
  background-color: #e6efee;
  margin-top: 2vh;
  margin-bottom: 5vh
}
.Rectangle-602 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #e6efee;
  margin-top: 10vh
}
.mytask_today {
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  color: #073c49 !important;
  text-align: left;
  margin-left: 5vh
}
.mytask_content {
  font-family: Lato;
  font-size: 18px;
  text-align: left;
  color: #073c49;
  margin-left: 5vh
}
.Path-733 {
  opacity: 0.3;
  border: solid 1px #81a1a6;
  background-color: #e6efee !important;
}
.Rectangle-556 {
  width: 124px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-557 {
  width: 148px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-558 {
  width: 124px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 1vh;
}
.Rectangle-605 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-562 {
  width: 124px;
  height: 9px;
  background-color: #81a1a6 !important;
  margin-top: 2vh
}
.mytask_upcoming {
  margin-top: 2vh;
  margin-bottom: 5vh
}
.Rectangle-612 {
  width: 240px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #e6efee;
  margin-left: 4vh;
  margin-top:2vh;
}
.myteamlist {
  margin-top: 8vh
}
.myteamlist_Rectangle-613 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #e6efee;
}
.myteamlist_Ellipse-3 {
  width: 58.7px;
  height: 58.7px;
  background-color: #e6efee;
  border-radius: 50%;
}
.myteamlist_Rectangle-578 {
  width: 141px !important;
  height: 24px;
  background-color: #e6efee;
  margin-left: 5vh !important
}
.myteamlist_Rectangle-582 {
  width: 103px !important;
  height: 12px;
  background-color: #e6efee;
  margin-top: 2vh !important;
  margin-left: 5vh !important
}
.myteamlist_Rectangle-586 {
  width: 173px !important;
  height: 12px;
  background-color: #e6efee;
  margin-top: 4vh !important;
  margin-left: 2vh !important
}
.myteamlist_text_item {
  margin-left: -30vh
}
.myteam_title {
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #073c49;
  margin-left: 5vh
}
.myteam_name {
  font-family: Lato;
  font-size: 22px;
  text-align: left;
  color: #12565e;
  padding-left: 5vh;
}
.myteam_desig {
  font-family: Lato;
  font-size: 12px;
  text-align: left;
  color: #666666;
  padding-left: 5vh;
}
.myteam_companycom {  
  font-family: Lato;
  font-size: 16px;
  text-align: left;
  color: #666666;
}
</style>
